import { useContext } from "react";
import FusionCharts from "fusioncharts";
import charts from "fusioncharts/fusioncharts.charts";
import ReactFusioncharts from "react-fusioncharts";
import { NetNewContext } from "./NetNewAccount";
import { NoResultFound } from "../../../assets/icons/FallBackComponents";

charts(FusionCharts);

const colorMap = {
  "intent": "#F78D30",
  "web": "#4CCA45",
  "linkedin": "#117EB8",
  "g2": "#F2726F",
}

export const NetNewChart = () => {
  const context = useContext(NetNewContext);
  const { data, icpSelected, segmentName, tabVal, generateLink, fromDate, toDate } = context;

  const dataset = [];

  Object.entries(data ?? {}).forEach(([source, data]) => {
    const dataArray = [];
    const sourceLower = source.toLowerCase();
    const color = colorMap[sourceLower] ?? (sourceLower.includes("linkedin") ? colorMap["linkedin"] : undefined);
    Object.entries(data ?? {}).forEach(([key, val]) => {
      const obj = {
        value: val,
        color: color,
        link: generateLink(icpSelected, segmentName, tabVal, key, source, fromDate, toDate),
      };
      if (key === "VERY HIGH") dataArray[0] = obj;
      else if (key === "HIGH") dataArray[1] = obj;
      else if (key === "MEDIUM") dataArray[2] = obj;
    })
    dataset.push({
      seriesname: source.toUpperCase(),
      plotBorderColor: "#ffffff",
      plotBorderThickness: "1",
      color: color,
      data: dataArray,
    });
  });

  const dataSource = {
    chart: {
      labelPadding: "15",
      plotSpacePercent: "50",
      showvalues: "0",
      drawcrossline: "0",
      yaxisname: "",
      xaxisname: "",
      caption: "",
      subcaption: "",
      theme: "fusion",
      showYAxisValues: "1",
      showAlternateHGridColor: "0",
      showBorder: "0",
      showShadow: "0",
      showtooltip: "1",
      plottooltext: "$seriesName $dataValue",
      baseFontSize: "10",
      labelFontSize: "10px",
      yAxisValueFontSize: "10px",
      legendItemFontSize: "10",
      legendItemFontBold: "1",
      showHoverEffect: "0",
    },
    categories: [
      {
        category: [
          {
            label: "Very High",
          },
          {
            label: "High",
          },
          {
            label: "Medium",
          },
        ],
      },
    ],
    dataset,
  };

  return (
    <>
      {Object.keys(data ?? {}).length > 0 ?
        <ReactFusioncharts type="stackedcolumn2d" width="100%" height="100%" dataFormat="JSON" dataSource={dataSource} />
        :
        <NoResultFound />
      }
    </>
  )
};
